import { render, staticRenderFns } from "./YMmpBeautifulBox.vue?vue&type=template&id=42f61b92&scoped=true&"
import script from "./YMmpBeautifulBox.vue?vue&type=script&lang=js&"
export * from "./YMmpBeautifulBox.vue?vue&type=script&lang=js&"
import style0 from "./YMmpBeautifulBox.vue?vue&type=style&index=0&id=42f61b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f61b92",
  null
  
)

export default component.exports